import Chartist from 'chartist'
window['Chartist'] = Chartist

export const ChartistPluginBarLabel = {

  create: options => chart => {
    const defaultOptions = {
      labelClass: 'ct-label',
      labelOffset: {
        x: 15,
        y: -10
      },
      textAnchor: 'middle'
    }

    options = Chartist.extend({}, defaultOptions, options)

    if (chart instanceof Chartist.Bar) {
      chart.on('draw', data => {
        if (data.type === 'bar' && data.value.y !== 0) {
          if (data.series.totals && data.series.totals.length) {
            let totals = data.series.totals
            if (chart.options.reverseData) {
              totals = totals.reverse()
            }

            const text = totals[data.index]
            data.group.elem('text', {
              x: data.x2 + options.labelOffset.x,
              y: data.value.y > 0 ? data.y2 + options.labelOffset.y : data.y1 + options.labelOffset.y,
              style: 'text-anchor: ' + options.textAnchor
            }, options.labelClass).text(text)
          }
        }
      })
    }
  }

}

export default ChartistPluginBarLabel
